export const FIELD_FORMAT_TYPE = {
  PERCENTAGE: 'percentage',
} as const;
